<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableCloudUserWarningData" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="delete">
                <Button type="success" size="small" @click="rowClick(row)">{{ $t('alarms.common.operationLog') }}</Button>
                <Button type="warning" size="small" @click="addOrUpdateHandle(row.id)">{{ $t('alarms.common.edit') }}</Button>
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="cloudUserWarningModal = true">{{ $t('alarms.common.delete') }}</Button>
                </span>
            </template>
        </Table>
        <!-- 操作日志详情 -->
        <alert-rule-operation-log v-if="alertRuleOperationLogVisible" ref="alertRuleOperationLog"></alert-rule-operation-log>
        <!-- 删除模式框 -->
        <Modal v-model="cloudUserWarningModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{alertRuleName}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="removeCloudUserWarning()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
            </div>
        </Modal>
        <!-- :page-size-opts="[2,4,6,8]" -->
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
        <!-- 弹窗，新增/编辑 -->
        <add-or-update-cloud-user-warning v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-cloud-user-warning>
    </div>
</template>
<script>
    import AlertRuleOperationLog from '../common/AlertRuleOperationLog.vue'
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import AddOrUpdateCloudUserWarning from '../cloud_user/AddOrUpdateCloudUserWarning'
    var tableCloudUserWarningVue = {};
    export default {
        name: 'TableCloudUserWarning',
        components: {
            AddOrUpdateCloudUserWarning,
            AlertRuleOperationLog
        },
        data () {
            return {
                alertRuleOperationLogVisible: false,
                addOrUpdateVisible:false,
                current:1,
                dataTotal:0,
                pageSize:10,
                cloudUserWarningModal:false,
                isDisable: false,
                modal_loading: false,
                stateType:["enabled","disabled"],
                val:'',
                alertRuleName:'',
                columns: [
                {
                    title: this.$t('alarms.common.alertRuleName'),
                    key: 'alertRuleName'
                },
                {
                    title: this.$t('alarms.common.status'),
                    key: 'state',
                    render: (h, params) => {
                        return h('div', [
                            h('i-switch', { // 数据库0 enabled,1 disabled
                                props: {
                                    type: 'primary',
                                    size: 'large',
                                    value: params.row.state == 'enabled' // 控制开关的打开或关闭状态，官网文档属性是value
                                },
                                on: {
                                    'on-change': () => {
                                        this.switch(params.index)
                                    }
                                }
                            }, [
                                h('span', {
                                    slot: 'open',
                                    domProps: {
                                        innerHTML: this.$t('alarms.common.enable')
                                    }
                                }),
                                h('span', {
                                    slot: 'close',
                                    domProps: {
                                        innerHTML: this.$t('alarms.common.disable')
                                    }
                                })
                            ])
                        ])
                    }
                }, 
                {
                    title: this.$t('alarms.common.monitorIndex'),
                    key: 'monitorIndexName'
                },
                {
                    title: this.$t('alarms.common.alertRule'),
                    key: 'alertRuleDesc'
                },
                {
                    title: this.$t('alarms.common.contact'),
                    key: 'contactNameList'
                },
                {
                    title: this.$t('alarms.common.delayType'),
                    key: 'delayName'
                },
                {
                    title: this.$t('alarms.common.delayCountdown'),
                    key: 'alarmDelayCountdown'
                },
                {
                    title: this.$t('alarms.common.scanType'),
                    key: 'scanTypeName'
                },
                {
                    title: this.$t('common.operation'),
                    width:200,
                    slot: 'delete'
                }],
                tableCloudUserWarningData:[]
            }
        },
        beforeCreate: function() {
            tableCloudUserWarningVue = this
        },
        mounted: function(){
            tableCloudUserWarningVue.getData();
        },
        methods: {
            showAll: function(){
                tableCloudUserWarningVue.getData();
            },
            // 分页显示数据
            /****************************************************/
            getData:function() {
                eventBus.$on('alertRuleSearchName',function(val){
                    tableCloudUserWarningVue.val=val;
                })
                //列表分页
                this.$api.alertRule.pageAlertRule({
                    "alertRuleName": tableCloudUserWarningVue.val,
                    "pageNum": this.current,
                    "pageSize": this.pageSize,
                    "monitorModule": 32,
                    "cloudUserName":this.$route.query.name
                })
                .then(res => {
                    this.tableCloudUserWarningData = res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                    for(var i=0;i<this.tableCloudUserWarningData.length;i++){
                        // 状态
                        this.tableCloudUserWarningData[i].state = this.stateType[this.tableCloudUserWarningData[i].state];
                    }
                });
            },
            changePage: function(current){
                this.current=current;
                tableCloudUserWarningVue.getData();
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                tableCloudUserWarningVue.getData();
            },
            // 销毁alertRuleSearchName
            beforeDestroy: function(){
                eventBus.$off('alertRuleSearchName');
            },
            // switch
            /****************************************************/
            switch (index) {
                this.index = index;
                // 打开是true,0启用 1禁用
                if (this.tableCloudUserWarningData[index].state == 'enabled') {
                    this.changeStatusMessage(this.tableCloudUserWarningData[index].id, 'state', 1)
                } else {
                    this.changeStatusMessage(this.tableCloudUserWarningData[index].id, 'state', 0)
                }
            },
            // 更新反馈信息某一字段
            changeStatusMessage: function (id, key, value) {
                // 编辑状态
                this.$api.alertRule.changeStatus({
                    "id": id,
                    "state": value
                })
                .then(res => {
                    tableCloudUserWarningVue.getData()
                })
            },
            // 删除
            /****************************************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.alertRuleName=this.tableCloudUserWarningData[index].alertRuleName;
            },
            removeCloudUserWarning: function(){
                this.isDisable = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.alertRule.deleteAlertRule("id",this.tableCloudUserWarningData[lineIndex].id)
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        tableCloudUserWarningVue.getData();
                        this.isDisable = false;
                        this.modal_loading = false;
                        this.cloudUserWarningModal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            },
            // 编辑报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(id){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id);
                })
            },
             // 操作日志
            /****************************************************/
            rowClick:function(row){
                this.alertRuleOperationLogVisible = true;
                this.$nextTick(function () {
                    this.$refs.alertRuleOperationLog.getAlertRuleOperationLogData(row);
                })
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/cloud_user/TableCloudUserWarning.vue